import React from "react";
import "./ToolsButton.css";

type Props = {
  title: string;
  icon: React.ReactNode;
  onClick: () => void;
  active?: boolean;
  style?: React.CSSProperties;
};

const ToolsButton = ({
  title,
  icon,
  onClick = () => {},
  active,
  style,
}: Props) => {
  return (
    <div
      style={{
        ...style,
      }}
      onClick={onClick}
      className={active ? "tools-button active" : "tools-button"}
    >
      <div
        style={{
          display: "block",
          margin: "auto",
          width: 54,
          textAlign: "center",
        }}
      >
        {icon}
      </div>
      <div
        style={{
          width: "calc(100% - 54px)",
          display: "block",
          margin: "auto",
        }}
      >
        {title}
      </div>
    </div>
  );
};

export default ToolsButton;
